import "../admin/css/style.css";
import { MDBCol, MDBInput, MDBRow } from "mdb-react-ui-kit";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import request from "superagent";
import Swal from "sweetalert2";
import { apisCategory, dataPlans, networks } from "./arrays";
import { appMainColor, baseApiUrl } from "../../services/setup";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect } from "react";

export default function ApiSettings() {
  const [rows, setRows] = useState([]);
  const [apiName, setApiName] = useState("");
  const [apiCat, setApiCat] = useState("");
  const [apiUrl, setApiUrl] = useState("");
  const [apiToken, setApiToken] = useState("");
  const [planType, setPlanType] = useState("");
  const [network, setNetwork] = useState("");

  const commonStyles = {
    // width: "100%",
    backgroundColor: "white",
    borderRadius: "10px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccc",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#888",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#333",
    },
  };

  useEffect(() => {
    handleDataFetch();
  }, []);

  const handleDataFetch = async () => {
    await request
      .get(baseApiUrl + "api/api_list")
      .type("application/json")
      .then((response) => {
        const list = response.body;

        console.log("LIST OF APIS", list);
        setRows(list);
      })
      .catch((err) => {
        // console.log("Error message:", err.response);
        // console.log("ERROR", err);
      });
  };

  const saveApis = async () => {
    if (navigator.onLine) {
      try {
        await request
          .post(baseApiUrl + "api/save_apis")
          .set("Content-Type", "application/json")
          .set("Accept", "application/json")
          .type("application/json")
          .send(rows);

        Swal.fire({
          icon: "success",
          title: "Updated successfully",
        });
      } catch (err) {
        Swal.fire({
          title: "Error!",
          text: "An error occurred. Please try again.",
          icon: "error",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "No internet connection",
      });
    }
  };

  const handleDelete = (index) => {
    setRows((prevRows) => prevRows.filter((_, i) => i !== index));
  };

  const handleAddRow = () => {
    const newRow = {
      ApiName: apiName,
      ApiCategory: apiCat,
      ApiUrl: apiUrl,
      PlanType: planType,
      Network: network,
      ApiToken: apiToken,
      Service: "Data",
    };

    // const { , apiCat, apiUrl, planType } = formData;
    if (!apiName || !apiCat || !apiUrl || !planType || !network || !apiToken) {
      Swal.fire({
        icon: "error",
        title: "Please fill in all fields before adding a row.",
      });
      return;
    }
    setRows((prevRows) => [...prevRows, newRow]);
    Swal.fire({
      icon: "success",
      title: "API added successfully",
    });
  };

  return (
    <MDBRow style={{ padding: "10px" }}>
      <div style={{ fontWeight: "900", padding: "20px" }}>API Settings</div>

      <MDBCol>
        <MDBRow>
          <div
            style={{
              fontSize: "12px",
              fontWeight: 900,
              textAlign: "left",
              marginBottom: "10px",
              color: "green",
            }}
          >
            Add API by choosing it from the dropdown below, which will add it
            directly to the apis table.
          </div>

          <MDBCol>
            <FormControl fullWidth>
              <InputLabel>API Category</InputLabel>
              <Select
                value={apiCat}
                sx={commonStyles}
                label="Api Category"
                onChange={(e) => {
                  setApiCat(e.target.value);
                }}
              >
                {apisCategory.map((prog, index) => (
                  <MenuItem key={index} value={prog}>
                    {prog}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBCol>

          <MDBCol>
            <FormControl fullWidth>
              <InputLabel>Network</InputLabel>
              <Select
                value={network}
                sx={commonStyles}
                label="Network"
                onChange={(e) => setNetwork(e.target.value)}
              >
                {networks.map((mode, index) => (
                  <MenuItem key={index} value={mode.name}>
                    {mode.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBCol>

          <MDBCol>
            <FormControl fullWidth>
              <InputLabel>Plan Type</InputLabel>
              <Select
                value={planType}
                sx={commonStyles}
                label="Plan Type"
                onChange={(e) => setPlanType(e.target.value)}
              >
                {dataPlans.map((cse, index) => (
                  <MenuItem key={index} value={cse}>
                    {cse}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBCol>
        </MDBRow>

        <MDBRow className="mt-3">
          <MDBCol>
            <MDBInput
              value={apiUrl}
              label="API Url"
              placeholder="API Url"
              onChange={(e) => {
                setApiUrl(e.target.value);
              }}
            />
          </MDBCol>
        </MDBRow>
        <MDBRow className="mt-3">
          <MDBCol>
            <MDBInput
              value={apiToken}
              onChange={(e) => {
                setApiToken(e.target.value);
              }}
              label="API Token"
              placeholder="API Token"
            />
          </MDBCol>
        </MDBRow>

        <MDBRow className="mt-3">
          <MDBCol>
            <MDBInput
              value={apiName}
              onChange={(e) => {
                setApiName(e.target.value);
              }}
              label="API Name"
              placeholder="API Name"
            />
          </MDBCol>
        </MDBRow>

        <MDBRow className="mt-2">
          <MDBCol>
            <button
              style={{ background: appMainColor }}
              onClick={handleAddRow}
              className="cus-button"
            >
              Add Api
            </button>
          </MDBCol>
        </MDBRow>

        <MDBCol>
          <table>
            <thead>
              <tr>
                <th>Api Name</th>
                <th>API Category</th>
                <th>API Url</th>
                <th>Plan Type</th>
                <th>Network</th>
                <th>Service</th>
                <th>Api Token</th>
                <th>Remove</th>
              </tr>
            </thead>

            <tbody>
              {rows.map((item, index) => (
                <tr key={index}>
                  <td>{item.ApiName}</td>
                  <td>{item.ApiCategory}</td>
                  <td>{item.ApiUrl}</td>
                  <td>{item.PlanType}</td>
                  <td>{item.Network}</td>
                  <td>{item.Service}</td>
                  <td>{item.ApiToken}</td>
                  <td>
                    <button
                      onClick={() => handleDelete(index)}
                      style={{
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        // width: "30px",
                      }}
                    >
                      <DeleteIcon sx={{ color: "gray", fontSize: 20 }} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <button
            style={{ background: appMainColor }}
            onClick={saveApis}
            className="cus-button w-50"
          >
            Update
          </button>
        </MDBCol>
      </MDBCol>
    </MDBRow>
  );
}
